import React from 'react';

export const CruiseItinerary = () => {
  return (
    <div className="outer-container">
      <div id="itinerary" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Cruise Itinerary</h2>
          </div>
        </div>
      </div>
      <div className="itinerary-container">
      <h1>11 Nights | Eastern Mediterranean | Celebrity Cruises: Celebrity Ascent</h1>
<div className="itinerary-details">
  <div className="day">
    <div className="day-location">
      <strong>Day 1:</strong> <i>Rome (Civitavecchia), Italy</i>
    </div>
    <span>Mon Sep 29, 2025 | Depart 05:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 2:</strong> <i>At Sea</i>
    </div>
    <span>Tue Sep 30, 2025</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 3:</strong> <i>Chania (Souda), Crete, Greece</i>
    </div>
    <span>Wed Oct 1, 2025 | 10:00am To 06:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 4:</strong> <i>Ephesus (Kusadasi), Turkey</i>
    </div>
    <span>Thu Oct 2, 2025 | 08:00am To 06:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 5:</strong> <i>Istanbul, Turkey</i>
    </div>
    <span>Fri Oct 3, 2025 | Arrive 02:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 6:</strong> <i>Istanbul, Turkey</i>
    </div>
    <span>Sat Oct 4, 2025 | Depart 10:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 7:</strong> <i>At Sea</i>
    </div>
    <span>Sun Oct 5, 2025</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 8:</strong> <i>Mykonos, Greece - Tender</i>
    </div>
    <span>Mon Oct 6, 2025 | 07:00am To 06:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 9:</strong> <i>Santorini, Greece - Tender</i>
    </div>
    <span>Tue Oct 7, 2025 | 07:00am To 08:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 10:</strong> <i>At Sea</i>
    </div>
    <span>Wed Oct 8, 2025</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 11:</strong> <i>Naples, Italy</i>
    </div>
    <span>Thu Oct 9, 2025 | 07:00am To 06:00pm</span>
  </div>
  <div className="day">
    <div className="day-location">
      <strong>Day 12:</strong> <i>Rome (Civitavecchia), Italy</i>
    </div>
    <span>Fri Oct 10, 2025 | Arrive 05:00am</span>
  </div>
</div>

      </div>
    </div>
  );
};
